import { useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, useHistory } from "react-router-dom";

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
	const user = useSelector((state) => state.auth.user);

	const accessToken = localStorage.getItem("admin:accessToken");
	const refreshToken = localStorage.getItem("admin:refreshToken");

	let beforeSignupUser = user?.id && !user?.bank_code;

	const history = useHistory();
	useLayoutEffect(() => {
		if (beforeSignupUser) {
			history.replace("/user/together/signup");
		}
	}, [beforeSignupUser]);

	return (
		<Route
			{...rest}
			render={(props) =>
				!!user?.is_influencer && !!accessToken && !!refreshToken ? (
					<>
						{/*메디슨맨님인 경우, 홈/상품 링크/사이트 관리/회원관리 메뉴 숨김처리 (2024.03.28) - ksb*/}
						{user?.id === 7 ? (
							<Redirect to="/reports_analysis/category" />
						) : (
							<Redirect to="/dashboard" />
						)}

						{/*{*/}
						{/*    (user?.role === "super_admin") ? (*/}
						{/*    <Redirect to="/dashboard"/>*/}
						{/*) :(user?.role === "level_1") ? (*/}
						{/*    <Redirect to="/products"/>*/}
						{/*) : (*/}
						{/*    <Redirect to="/edit/channel"/>*/}
						{/*)}*/}
					</>
				) : (
					<Component {...props} />
				)
			}
		/>
	);
};

export default PublicRoute;
